import React from "react";
import styles from "./HistorySkeleton.module.scss";

export const HistorySkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      {Array.from({ length: 2 }).map((_, groupIdx) => (
        <div key={groupIdx} className={styles.dateSection}>
          <div className={styles.dateSkeleton} />
          <div className={styles.items}>
            {Array.from({ length: 3 }).map((_, itemIdx) => (
              <div key={itemIdx} className={styles.card}>
                <div className={styles.infoRow}>
                  <div className={styles.leftSide}>
                    <div className={styles.nameSkeleton} />
                    <div className={styles.subtitleSkeleton} />
                  </div>
                  <div className={styles.rightSide}>
                    <div className={styles.timeSkeleton} />
                    <div className={styles.priceSkeleton} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
